import React, { memo, useMemo } from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { colorsTheme } from 'resources/theme/styled/colors';
import { IntakeSubmissionFromQuery } from 'api/crm/intakeFormAPI';

// components
import ApplicationDetails from 'components/Additional/DetailsSections/Connections/ApplicationDetails';
import { Button, Text } from '@ui';

interface IProps {
  data: IntakeSubmissionFromQuery;
  isSelected: boolean;
  onView?: () => void;
  onSelect?: () => void;
}

const Application = memo(({ data, isSelected, onSelect, onView }: IProps) => {
  const { t } = useTranslation('connections');

  const content = useMemo(() => {
    if (isSelected) {
      return (
        <Text color={colorsTheme.colorPrimaryD2}>
          {t('applications.current')}
        </Text>
      );
    }
    if (onSelect) {
      return (
        <Button onClick={onSelect}>{t('applications.switch_button')}</Button>
      );
    }
    if (onView) {
      return <Button onClick={onView}>{t('applications.view_button')}</Button>;
    }

    return null;
  }, [onSelect, onView, isSelected]);

  return (
    <StyledApplicationDetails
      removeMargin
      data={{
        name: data.directClientName,
        type: data.type,
        status: data.state,
      }}
    >
      {content}
    </StyledApplicationDetails>
  );
});

const StyledApplicationDetails = styled(ApplicationDetails)`
  .ant-row {
    align-items: center;
  }
`;

export default Application;
